'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import LinkPagination from '../link-pagination';

const CategoryPagination = props => {
  const { currentPage, totalPages } = props;
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const pathParts = pathname.split('/').filter(Boolean);

  const generatePaginationHref = nextPage => {
    const nextPathParts = pathParts.slice(0);
    const paginationIndex = nextPathParts.findIndex(x => x === 'p');
    const hasPaginationKey = paginationIndex !== -1;
    const hasPagination = hasPaginationKey && /^\d+$/.test(nextPathParts[paginationIndex + 1]);
    const searchParamStr = searchParams.toString();

    if (nextPage === 1) {
      if (hasPagination) {
        nextPathParts.splice(paginationIndex, 2);
      } else if (hasPaginationKey) {
        nextPathParts.splice(paginationIndex, 1);
      }
    } else {
      if (hasPagination) {
        nextPathParts[paginationIndex + 1] = String(nextPage);
      } else if (hasPaginationKey) {
        nextPathParts.push(String(nextPage));
      } else {
        nextPathParts.push('p', String(nextPage));
      }
    }

    return `/${nextPathParts.join('/')}` + (searchParamStr ? `?${searchParamStr}` : '');
  };

  const numericTotalPages = typeof totalPages === 'number' ? totalPages : parseInt(totalPages);
  const numericCurrentPage = typeof currentPage === 'number' ? currentPage : parseInt(currentPage);

  if (!numericTotalPages || numericTotalPages <= 1) {
    return null;
  }

  return (
    <LinkPagination
      currentPage={numericCurrentPage}
      totalPages={numericTotalPages}
      generatePaginationHref={generatePaginationHref}
      className='mt-[30px] lg_mt-[54px]'
    />
  );
};

export default CategoryPagination;
